var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRedDelete = function SvgRedDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F44",
    d: "M5.405 11.002a.667.667 0 0 0 .667-.667v-4a.667.667 0 1 0-1.334 0v4a.667.667 0 0 0 .667.667m6.667-8H9.405v-.667a2 2 0 0 0-2-2H6.072a2 2 0 0 0-2 2v.667H1.405a.667.667 0 1 0 0 1.333h.667v7.334a2 2 0 0 0 2 2h5.333a2 2 0 0 0 2-2V4.335h.667a.667.667 0 1 0 0-1.333m-6.667-.667a.667.667 0 0 1 .667-.666h1.333a.667.667 0 0 1 .667.666v.667H5.405zm4.667 9.334a.667.667 0 0 1-.667.666H4.072a.667.667 0 0 1-.667-.666V4.335h6.667zm-2-.667a.667.667 0 0 0 .666-.667v-4a.667.667 0 0 0-1.333 0v4a.667.667 0 0 0 .667.667"
  })));
};
export default SvgRedDelete;